import axios from 'axios'
import {getUserToken} from '../../functions.js'
import store from '../../vuex/store'
import {getServerApi} from '../../config/deployment'
import { captureException } from '@/utils/reporting/reportingService.js'
import { getCurrentFirebaseUser } from '@/platform/auth/services/authService.js'

let envUri = getServerApi()
let userUri = envUri+'/api/user/v2'
let userPaymentDetailsUri = envUri+'/api/user/v2/paymentDetails'
let userCompanyDetailsUri = envUri+'/api/user/v2/company'


export const getUserByUid = async (uid) => {
  try{
    // throw "false positive error for testing!" // IMPORTANT: use this line ONLY FOR TESTING!!!
    const token = await getUserToken()
    const response = await axios.get(userUri, {params: { uid: uid, token: token }} )
    return response.data.body
  }catch(ex){
    captureException('userRepository.getUserByUid() > ex: ', ex)
    return false
  }
}


export const postUser = async (createUserCommand)=>{
  try{
    // throw "false positive error for testing!" // IMPORTANT: use this line ONLY FOR TESTING!!!
    const response = await axios.post(userUri, createUserCommand)
    return response.data.body
  }catch(ex){
    captureException('userRepository.postUser() > ex: ', ex)
    return false
  }
}

export const getUserUid = () => {
  var user = getCurrentFirebaseUser()
  if (user) {
    return user.uid
  } else {
    return false
  }
}

export const getUserPaymentDetails=(userUId)=>{
  return getUserToken()
    .then(res => {
      return axios.get(userPaymentDetailsUri, {
        params: {
          uid: userUId,
          token:res
        }
      })
    })
    .then(response => {
      if (response.data.body && response.data.body.paymentDetails) return response.data.body.paymentDetails
      else return false
    })
    .catch(err => {
      return false
    })
}

export const updateEntireUser = async ({uid, userObj})=>{
  try{
    const token = await getUserToken()
    userObj.token = token
    userObj.uid = uid
    return await axios.put(userUri, userObj)
  }catch(ex){
    console.log("userRepo | updateEntireUser > ex: ", ex)
    captureException('userRepository.updateEntireUser() > ex: ', ex)
    return false
  }
}

export const updateUserPaymentDetails=(userUId, paymentDetails)=>{
  return getUserToken()
    .then(token => {
      paymentDetails.token = token
      paymentDetails.uid = userUId
      return axios.post(userPaymentDetailsUri, paymentDetails)
    })
    .then(res => {
      return res.data.body
    })
    .catch(err => {
      return false
    })
}

export const updateUserCompanyDetails=(userUId, companyDetails)=>{
  return getUserToken()
    .then(token => {
      companyDetails.token = token
      companyDetails.uid = userUId
      return axios.post(userCompanyDetailsUri, companyDetails)
    })
    .then(res => {
      return res.data.body
    })
    .catch(err => {
      return false
    })
}

export const updateCurrentUserRootLevelKeys=(updates)=>{
  if(store.getters.user.uid) {
    const keys = Object.keys(updates)
    for(const key of keys){
      store.getters.user[key]=updates[key]
    }
  }
}

export const checkForLoginOrGoAnonymous = () => {
  return new Promise((resolve, reject) => {
    let currentUser = getCurrentFirebaseUser()
    if (currentUser) resolve(currentUser)
    else {
      firebase.auth().signInAnonymously()
        .then(user => {
          resolve(user)
        })
        .catch(err =>{
          console.log("userRepo | checkForLoginOrGoAnonymous | err:", err)
          reject("Cannot sign in anonymously")
        })
    }
  })
}

export const isUserMoowleVerified = (user) => {
  try {
    if (!user.emailVerified) {
      return false;
    }
    if (!user.firstName && !user.lastName) {
      return false;
    }
    if (!user.googleLinked && !user.facebookLinked) {
      return false;
    }
    if (!user.pictureUrl) {
      return false;
    }

    return true;

  } catch (err) {
    return false
  }
};



// WEBPACK FOOTER //
// ./src/users/repositories/userRepository.js